import { Box, IconButton, Stack } from '@mui/material';
import { CommentNoteIcon, MessageIcon } from '@synergy/theme';
import { PaloNextThemeProvider } from '@synergy/theme-palo';
import { PoolTooltip, PoolTypography } from '@synergy/components-next';
import { UserIcon } from '@synergy/theme-next';

import { BonusCondition } from '../../models/bonus-condition';
import { EmbeddedContact } from '../../../models/embedded-contact';

type AdditionalInfoColumnProps = {
    bonusConditions: BonusCondition[];
    internalNote?: string | null;
    noteFromSupplier?: string | null;
};

const TooltipContact = (props: { contact: EmbeddedContact }) => {
    return (
        <Stack>
            <Box>
                {props.contact.firstName} {props.contact.lastName}
            </Box>
            <Box color="grey.800">{props.contact.mainPhone}</Box>
            <Box color="grey.800"> {props.contact.mainEmail}</Box>
        </Stack>
    );
};

export const AdditionalInfoColumn = ({
    bonusConditions,
    internalNote,
    noteFromSupplier,
}: AdditionalInfoColumnProps) => {
    return (
        <PaloNextThemeProvider>
            <Stack flexDirection="row">
                <PoolTooltip
                    title={
                        <Stack gap={0.5}>
                            <Box sx={{ pb: 1 }}>
                                <PoolTypography
                                    sx={{ fontWeight: 600 }}
                                    variant="body1"
                                    translationId="app.bonusSettlementsSupplierOverview.table.responsibleContact"
                                />
                            </Box>

                            {bonusConditions.map(
                                bonusCondition =>
                                    bonusCondition.responsibleContact && (
                                        <Box key={bonusCondition.id}>
                                            <strong>{bonusCondition.title}</strong>
                                            <TooltipContact contact={bonusCondition.responsibleContact} />
                                        </Box>
                                    )
                            )}
                        </Stack>
                    }
                    placement="top"
                    variant="light"
                >
                    <span>
                        <IconButton disabled={bonusConditions.length < 1}>
                            <UserIcon
                                sx={{
                                    color: bonusConditions.length < 1 ? '' : theme => theme.palette.common.black,
                                }}
                            />
                        </IconButton>
                    </span>
                </PoolTooltip>
                <PoolTooltip
                    title={
                        internalNote && (
                            <Stack gap={0.5}>
                                <Box>
                                    <PoolTypography
                                        sx={{ fontWeight: 600 }}
                                        variant="body2"
                                        translationId="app.bonusSettlementsSupplierOverview.table.internalNote"
                                    />
                                </Box>
                                {internalNote}
                            </Stack>
                        )
                    }
                    placement="top"
                    variant="light"
                >
                    <span>
                        <IconButton disabled={!internalNote}>
                            <MessageIcon
                                sx={{
                                    color: !internalNote ? '' : theme => theme.palette.common.black,
                                }}
                            />
                        </IconButton>
                    </span>
                </PoolTooltip>
                <PoolTooltip
                    title={
                        noteFromSupplier && (
                            <Stack gap={0.5}>
                                <Box>
                                    <PoolTypography
                                        sx={{ fontWeight: 600 }}
                                        variant="body2"
                                        translationId="app.bonusSettlementsSupplierOverview.table.noteFromSupplier"
                                    />
                                </Box>
                                {noteFromSupplier}
                            </Stack>
                        )
                    }
                    placement="top"
                    variant="light"
                >
                    <span>
                        <IconButton disabled={!noteFromSupplier}>
                            <CommentNoteIcon
                                sx={{
                                    color: !noteFromSupplier ? '' : theme => theme.palette.common.black,
                                }}
                            />
                        </IconButton>
                    </span>
                </PoolTooltip>
            </Stack>
        </PaloNextThemeProvider>
    );
};
